import {
  ChangeEventHandler,
  FocusEvent,
  FocusEventHandler,
  MouseEventHandler,
  useRef,
} from "react";

type DateInputProps = {
  value: string;
  placeholder?: string;
  onChange: ChangeEventHandler<HTMLInputElement>;
  onClear?: MouseEventHandler<HTMLDivElement>;
  onBlur?: FocusEventHandler<HTMLInputElement>;
  label?: string;
  id?: string;
  name?: string;
  minDate?: string;
  maxDate?: string;
  disabled?: boolean;
  showPickerOnFocus?: boolean;
};

const DateInput = (props: DateInputProps) => {
  const {
    value,
    placeholder,
    onChange,
    onBlur,
    id,
    name,
    minDate,
    maxDate,
    disabled = false,
    showPickerOnFocus = false,
  } = props;

  const inputRef = useRef<HTMLInputElement>(null);

  return (
    <input
      type={placeholder && !value ? "text" : "date"}
      ref={inputRef}
      placeholder={placeholder}
      onChange={onChange}
      onFocus={() => {
        if (inputRef.current) {
          if (placeholder) {
            inputRef.current.type = "date";
          }
          if (showPickerOnFocus) {
            //@ts-ignore
            inputRef.current.showPicker();
          }
        }
      }}
      onBlur={(e: FocusEvent<HTMLInputElement>) => {
        onBlur && onBlur(e);
        if (inputRef.current && !value && placeholder)
          inputRef.current.type = "text";
      }}
      value={value}
      min={minDate}
      max={maxDate || "9999-12-31"}
      name={name}
      id={id}
      autoComplete="off"
      disabled={disabled}
    />
  );
};

export default DateInput;
